
import { IGoal, IGoalCluster, ITableRes } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const goalbankAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    GET_domains: builder.query<any, any>({
      query: (params) => ({
        url: `/domains/`,
        params
      }),
      providesTags: ['domains'],
    }),

    GET_domainsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/domains/',
        params
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['domains'],
    }),

    GET_domainById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/domains/${id}/`,
        }
      },
      providesTags: ['domain'],
    }),

    GET_clusters: builder.query<any, any>({
      query: (params) => ({
        url: `/clusters/`,
        params
      }),
      providesTags: ['clusters'],
    }),

    GET_clusterById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/clusters/${id}/`,
        }
      },
      providesTags: ['cluster'],
    }),

    GET_goals: builder.query<any, any>({
      query: (params) => ({
        url: `/goals/`,
        params
      }),
      providesTags: ['goals'],
    }),

    GET_goalById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/goals/${id}/`,
        }
      },
      providesTags: ['goal'],
    }),

    GET_chapterById: builder.query<any, string>({
      query: (id) => {
        return {
          url: `/course-chapters/${id}/`,
        }
      },
      providesTags: ['goal'],
    }),

    GET_goalClusters: builder.query<any, any>({
      query: (params) => ({
        url: `/goalbank/`,
        params
      }),
      providesTags: ['goal-clusters'],
    }),

    GET_goalContentAreasSelect: builder.query<any, void>({
      query: () => ({
        url: '/goal/content-areas/select/',
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['goal-content-areas'],
    }),

    GET_goalDomainsSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/goal/domains/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['goal-domains'],
    }),

    GET_goalClustersSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/goal/clusters/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['goal-clusters'],
    }),

    GET_goalComplexitiesSelect: builder.query<any, void>({
      query: () => ({
        url: '/goal/complexities/select/',
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['goal-complexities'],
    }),

    GET_complexities: builder.query<any, any>({
      query: (params) => ({
        url: `/goal/complexities/select/`,
        params
      }),
      providesTags: ['verbs'],
    }),

    GET_complexityById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/complexities/${id}/`,
        }
      },
      providesTags: ['verb'],
    }),



    GET_highlights: builder.query<any, any>({
      query: (params) => ({
        url: `/highlights/`,
        params
      }),
      providesTags: ['highlights'],
    }),

    GET_highlightById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/highlights/${id}/`,
        }
      },
      providesTags: ['highlight'],
    }),

    POST_highlight: builder.mutation<any, any>({
      query: (body) => ({
        url: `/highlights/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal', 'highlights', 'highlight'],
    }),

    DELETE_highlight: builder.mutation<any, string>({
      query: (id) => ({
        url: `/highlights/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal', 'highlights', 'highlight'],
    }),



    GET_slo: builder.query<any, any>({
      query: (params) => ({
        url: `/student-learning-objectives/`,
        params
      }),
      providesTags: ['slos'],
    }),

    GET_sloById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/student-learning-objectives"/${id}/`,
        }
      },
      providesTags: ['slo'],
    }),

    POST_slo: builder.mutation<any, any>({
      query: (body) => ({
        url: `/student-learning-objectives/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal', 'slos', 'slo'],
    }),

    DELETE_slo: builder.mutation<any, string>({
      query: (id) => ({
        url: `/student-learning-objectives/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal', 'slos', 'slo'],
    }),


    GET_measures: builder.query<any, any>({
      query: (params) => ({
        url: `/measures/`,
        params
      }),
      providesTags: ['benchmarks'],
    }),
    GET_measuresSelect: builder.query<any, any>({
      query: (params) => ({
        url: '/measures/select/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: any) => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['benchmarks'],
    }),
    GET_measureById: builder.query<any, string>({
      query: (id) => {
        return {
          url: `/measures/${id}/`,
        }
      },
      providesTags: ['benchmark'],
    }),
    GET_measureGenerateRubricSections: builder.query<any, {id: string, cells: any}>({
      query: ({id, cells}) => {
        return {
          url: `/measures/${id}/generate-rubric-sections/?count=${cells}`,
        }
      },
      providesTags: ['benchmark'],
    }),
    GET_measureStudent: builder.query<any, {id: string, student: string}>({
      query: ({id, student}) => {
        return {
          url: `/measures/${id}/student/${student}/`,
        }
      },
      providesTags: ['benchmark'],
    }),
    GET_measureGroup: builder.query<any, {id: string, group: string}>({
      query: ({id, group}) => {
        return {
          url: `/measures/${id}/group/${group}/`,
        }
      },
      providesTags: ['benchmark'],
    }),
    POST_measure: builder.mutation<any, any>({
      query: (body) => ({
        url: `/measures/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal', 'benchmarks', 'benchmark'],
    }),

    PATCH_measure: builder.mutation<any, any>({
      query: ({id, body}) => ({
        url: `/measures/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['goal', 'benchmarks', 'benchmark'],
    }),

    DELETE_measure: builder.mutation<any, string>({
      query: (id) => ({
        url: `/measures/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal', 'benchmarks', 'benchmark'],
    }),



    POST_topic: builder.mutation<any, any>({
      query: (body) => ({
        url: `/topics/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_topic: builder.mutation<any, string>({
      query: (id) => ({
        url: `/topics/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),



    GET_skills: builder.query<any, any>({
      query: (params) => ({
        url: `/skills/`,
        params
      }),
      providesTags: ['skills'],
    }),

    GET_skillById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/skills/${id}/`,
        }
      },
      providesTags: ['skill'],
    }),

    POST_skill: builder.mutation<any, any>({
      query: (body) => ({
        url: `/skills/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal', 'skills', 'skill'],
    }),

    DELETE_skill: builder.mutation<any, string>({
      query: (id) => ({
        url: `/skills/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal', 'skills', 'skill'],
    }),


    POST_courseChapterObjective: builder.mutation<any, any>({
      query: (body) => ({
        url: `/course-chapter-objectives/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_courseChapterObjective: builder.mutation<any, string>({
      query: (id) => ({
        url: `/course-chapter-objectives/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),



    GET_fluencies: builder.query<any, any>({
      query: (params) => ({
        url: `/fluencies/`,
        params
      }),
      providesTags: ['fluencies'],
    }),

    GET_fluencyById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/fluencies/${id}/`,
        }
      },
      providesTags: ['fluency'],
    }),

    POST_fluency: builder.mutation<any, any>({
      query: (body) => ({
        url: `/fluencies/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal', 'fluencies', 'fluency'],
    }),

    DELETE_fluency: builder.mutation<any, string>({
      query: (id) => ({
        url: `/fluencies/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal', 'fluencies', 'fluency'],
    }),


    GET_practices: builder.query<any, any>({
      query: (params) => ({
        url: `/practices/`,
        params
      }),
      providesTags: ['practices'],
    }),

    GET_practiceById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/practices/${id}/`,
        }
      },
      providesTags: ['practice'],
    }),

    POST_practice: builder.mutation<any, any>({
      query: (body) => ({
        url: `/practices/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal', 'practices', 'practice'],
    }),

    DELETE_practice: builder.mutation<any, string>({
      query: (id) => ({
        url: `/practices/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal', 'practices', 'practice'],
    }),


    GET_successCriteria: builder.query<any, any>({
      query: (params) => ({
        url: `/success-criterias/`,
        params
      }),
      providesTags: ['success-criterias'],
    }),

    GET_successCriteriaById: builder.query<IGoal, string>({
      query: (id) => {
        return {
          url: `/success-criterias/${id}/`,
        }
      },
      providesTags: ['success-criteria'],
    }),

    POST_successCriteria: builder.mutation<any, any>({
      query: (body) => ({
        url: `/success-criterias/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal', 'success-criterias', 'success-criteria'],
    }),

    DELETE_successCriteria: builder.mutation<any, string>({
      query: (id) => ({
        url: `/success-criterias/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal', 'success-criterias', 'success-criteria'],
    }),



    POST_goalbankQuestion: builder.mutation<any, any>({
      query: (body) => ({
        url: `/goalbank-questions/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_goalbankQuestion: builder.mutation<any, string>({
      query: (id) => ({
        url: `/goalbank-questions/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),



    POST_goalbankUnderstanding: builder.mutation<any, any>({
      query: (body) => ({
        url: `/goalbank-understandings/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_goalbankUnderstanding: builder.mutation<any, string>({
      query: (id) => ({
        url: `/goalbank-understandings/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),



    POST_goalbankLesson: builder.mutation<any, any>({
      query: (body) => ({
        url: `/goalbank-lesson/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_goalbankLesson: builder.mutation<any, string>({
      query: (id) => ({
        url: `/goalbank-lessons/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),



    POST_goalbankActivity: builder.mutation<any, any>({
      query: (body) => ({
        url: `/goalbank-activities/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_goalbankActivity: builder.mutation<any, string>({
      query: (id) => ({
        url: `/goalbank-activities/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),



    POST_goalbankExercise: builder.mutation<any, any>({
      query: (body) => ({
        url: `/goalbank-exercises/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_goalbankExercise: builder.mutation<any, string>({
      query: (id) => ({
        url: `/goalbank-exercises/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),



    POST_goalbankResource: builder.mutation<any, any>({
      query: (body) => ({
        url: `/goalbank-resources/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['goal'],
    }),

    DELETE_goalbankResource: builder.mutation<any, string>({
      query: (id) => ({
        url: `/goalbank-resources/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['goal'],
    }),


    GET_goalProgression: builder.query<any, any>({
      query: (id) => ({
        url: `/goal-progression/${id}/`,
      }),
      providesTags: ['goal-progression'],
    }),

  }),
})

export const { 
  useGET_domainsQuery,
  useGET_domainsSelectQuery,
  useGET_domainByIdQuery, 
  useGET_clustersQuery,
  useGET_clusterByIdQuery, 
  useGET_goalsQuery,
  useGET_goalByIdQuery, 

  useGET_chapterByIdQuery, 
  useGET_goalClustersQuery, 
  useGET_goalContentAreasSelectQuery,
  useGET_goalDomainsSelectQuery,
  useGET_goalClustersSelectQuery,  
  useGET_goalComplexitiesSelectQuery, 
  useGET_goalProgressionQuery,

  usePOST_courseChapterObjectiveMutation, 
  useDELETE_courseChapterObjectiveMutation,
  
  useGET_complexitiesQuery,
  useGET_complexityByIdQuery,

  useGET_fluenciesQuery,
  useGET_fluencyByIdQuery,
  usePOST_fluencyMutation, 
  useDELETE_fluencyMutation,

  useGET_highlightsQuery,
  useGET_highlightByIdQuery,
  usePOST_highlightMutation, 
  useDELETE_highlightMutation,

  useGET_measuresQuery,
  useGET_measuresSelectQuery,
  useGET_measureByIdQuery,
  useLazyGET_measureGenerateRubricSectionsQuery,
  useGET_measureStudentQuery,
  useGET_measureGroupQuery,

  usePOST_measureMutation, 
  usePATCH_measureMutation, 
  useDELETE_measureMutation,

  useGET_sloQuery,
  useGET_sloByIdQuery,
  usePOST_sloMutation, 
  useDELETE_sloMutation,

  useGET_skillsQuery,
  useGET_skillByIdQuery,
  usePOST_skillMutation, 
  useDELETE_skillMutation,

  usePOST_topicMutation, 
  useDELETE_topicMutation,

  useGET_practicesQuery,
  useGET_practiceByIdQuery,
  usePOST_practiceMutation, 
  useDELETE_practiceMutation,

  useGET_successCriteriaQuery,
  useGET_successCriteriaByIdQuery,
  usePOST_successCriteriaMutation, 
  useDELETE_successCriteriaMutation,

  usePOST_goalbankQuestionMutation, 
  useDELETE_goalbankQuestionMutation,
  usePOST_goalbankUnderstandingMutation, 
  useDELETE_goalbankUnderstandingMutation,
  usePOST_goalbankLessonMutation, 
  useDELETE_goalbankLessonMutation,
  usePOST_goalbankActivityMutation, 
  useDELETE_goalbankActivityMutation,
  usePOST_goalbankExerciseMutation, 
  useDELETE_goalbankExerciseMutation,
  usePOST_goalbankResourceMutation, 
  useDELETE_goalbankResourceMutation

 } = goalbankAPI
